import upsell from "../upsell"
import primer from "../primer"

export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),
  ...upsell("basic_annual"),
  ...primer(),

  onInit() {
    this.store.values.hideApm = false
    this.initUpsell()
    this.addConfirmationEventListener()
    this.initPrimer({
      checkoutCompletePath: this.getThankYouPath(),
    })
  },
})
